var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 18.25H19.625V19.625H0.375V18.25ZM17.5625 6.5625C17.7448 6.5625 17.9197 6.49006 18.0486 6.36113C18.1776 6.2322 18.25 6.05733 18.25 5.875V3.8125C18.2499 3.67121 18.2063 3.53337 18.1252 3.41773C18.044 3.3021 17.9291 3.21429 17.7962 3.16625L10.2338 0.416247C10.0827 0.361637 9.9173 0.361637 9.76625 0.416247L2.20375 3.16625C2.07088 3.21429 1.95603 3.3021 1.87484 3.41773C1.79365 3.53337 1.75006 3.67121 1.75 3.8125V5.875C1.75 6.05733 1.82243 6.2322 1.95136 6.36113C2.0803 6.49006 2.25516 6.5625 2.4375 6.5625H3.125V15.5H1.75V16.875H18.25V15.5H16.875V6.5625H17.5625ZM3.125 4.29375L10 1.79125L16.875 4.29375V5.1875H3.125V4.29375ZM11.375 15.5H8.625V6.5625H11.375V15.5ZM4.5 6.5625H7.25V15.5H4.5V6.5625ZM15.5 15.5H12.75V6.5625H15.5V15.5Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingIcon);
export default __webpack_public_path__ + "static/media/bankingIcon.7d8d99508cafad463cbc103479ad5075.svg";
export { ForwardRef as ReactComponent };